import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatusDirective } from './status.directive';
import { LoadingComponent } from './loading.component';

@NgModule({
  declarations: [
    StatusDirective,
    LoadingComponent,
  ],
  entryComponents: [
    LoadingComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    StatusDirective
  ]
})
export class StatusModule { }
